<template #default>
    <form
        v-if="status.detail"
        @submit.prevent="propertyTenureUUID ? requestUpdate() : requestCreate()"
    >
        <b-form-group
            :label="$t('label.name')"
            label-cols="4"
            label-align="left"
        >
            <b-form-input
                v-model.trim="createForm.name"
                :class="{ 'is-invalid': submitted && !$v.createForm.name.required }"
                autocomplete="off"
            ></b-form-input>
            <b-form-invalid-feedback v-if="submitted && !$v.createForm.name.required" class="text-right">
                {{ $t("message.requiredX", [$t("label.name")]) }}
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
            :label="$t('label.description')"
            label-cols="4"
            label-align="left"
        >
            <b-form-textarea
                v-model.trim="createForm.description"
            ></b-form-textarea>
        </b-form-group>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end w-100">
            <b-button
                type="button"
                variant="danger"
                class="mr-2 col-2"
                @click="$emit('done')"
            >{{ $t('label.cancel') }}</b-button>
            <b-button
                type="submit"
                variant="info"
                class="col-2"
                :disabled="!status.save"
            >
                <span v-if="status.save">
                    {{ propertyTenureUUID ? $t('label.updateX', []) : $t('label.createX', []) }}
                </span>
                <div v-else>
                    <b-spinner small />
                </div>
            </b-button>
        </div>
    </form>
    <div v-else class="d-flex justify-content-center align-items-center m-3">
        <b-spinner class="m-5" variant="info" role="status"></b-spinner>
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { propertyTenureMethods } from "@/state/api";
import { PROPERTY_TENURE_MODULE } from "@/state/api/propertyTenure.state";

export default {
    props: {
        propertyTenureUUID: {
            type: String,
            required: false,
        },
        searchCriteria: {
            type: Object,
            required: false,
        },
    },
    validations() {
        return {
            createForm: {
                name: { required },
            },
        };
    },
    async created() {
        await this.getPropertyTenureData();
    },
    data() {
        return {
            submitted: false,
            createForm: this.defaultForm(),
        };
    },
    methods: {
        ...propertyTenureMethods,
        defaultForm() {
            return {
                uuid: "",
                name: "",
                description: "",
            };
        },
        async getPropertyTenureData() {
            if (this.propertyTenureUUID) {
                await this.getPropertyTenure({ uuid: this.propertyTenureUUID })
                    .then((result) => {
                        if (result?.success) {
                            this.createForm = {
                                uuid: this.data.uuid,
                                name: this.data.name,
                                description: this.data.description,
                            };
                        }
                    });
            }
        },
        requestCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                };
                this.createPropertyTenure({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        requestUpdate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                };
                this.updatePropertyTenure({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        resetForm() {
            this.createForm = this.defaultForm();
            this.submitted = false;
            this.$v.$reset();
        },
    },
    computed: {
        ...mapState(PROPERTY_TENURE_MODULE, ['status']),
        data() {
            return this.$store.state.api.propertyTenure.details;
        },
    },
}
</script>
